import { render, staticRenderFns } from "./weier_print_label.vue?vue&type=template&id=b2d126ce&scoped=true&"
import script from "./weier_print_label.vue?vue&type=script&lang=js&"
export * from "./weier_print_label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d126ce",
  null
  
)

export default component.exports